export default __webpack_public_path__ + "static/media/vs-code.54c2de39.png";